'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

function parseContentPropFromPseudoElement(pseudo, selector) {
    if (pseudo === void 0) { pseudo = ':before'; }
    if (selector === void 0) { selector = 'body'; }
    var el = document.querySelector(selector);
    var content = window.getComputedStyle(el, pseudo).content;
    if (content && content !== '"normal"') {
        return content.replace(/^["']|["']$/g, '');
    }
    return '';
}

function useCssBreakpoints() {
    var _a = react.useState(), state = _a[0], setState = _a[1];
    react.useEffect(function () {
        var mounted = true;
        var rAF = null;
        var onResize = function () {
            if (!mounted) {
                return;
            }
            if (rAF) {
                window.cancelAnimationFrame(rAF);
            }
            var breakpoint = parseContentPropFromPseudoElement();
            rAF = window.requestAnimationFrame(function () { return setState(breakpoint); });
        };
        window.addEventListener('resize', onResize, { passive: true });
        onResize();
        return function () {
            mounted = false;
            rAF = null;
            window.removeEventListener('resize', onResize);
        };
    }, []);
    return state;
}

exports.useCssBreakpoints = useCssBreakpoints;
